/**
 * Splash.ts — Controla as 4 status lines do splash inicial e o fade-out.
 *
 * Linhas: token / conexao / auth / partida.
 * Refator de tres.php:763-784 + 2117-2120.
 */

export type LinhaStatus = 'token' | 'conexao' | 'auth' | 'partida';

export class Splash {
  private readonly elemento: HTMLElement;
  private readonly elJogo: HTMLElement;
  private readonly linhas: Record<LinhaStatus, HTMLElement>;

  constructor() {
    this.elemento = obrigatorio('swSplash');
    this.elJogo = obrigatorio('swJogo');
    this.linhas = {
      token:    obrigatorio('swStatusToken'),
      conexao:  obrigatorio('swStatusConexao'),
      auth:     obrigatorio('swStatusAuth'),
      partida:  obrigatorio('swStatusPartida'),
    };
  }

  mostrar(linha: LinhaStatus): void {
    this.linhas[linha].style.display = '';
  }

  ok(linha: LinhaStatus, texto: string): void {
    const el = this.linhas[linha];
    el.classList.remove('aguardando');
    el.classList.add('ok');
    const icone = el.querySelector('.sw-status-icone');
    if (icone) {
      icone.classList.remove('aguardando');
      icone.innerHTML = '&#x2713;';
    }
    const span = el.querySelector('span:last-child');
    if (span) span.textContent = texto;
  }

  erro(linha: LinhaStatus, texto: string): void {
    const el = this.linhas[linha];
    el.classList.remove('aguardando');
    el.classList.add('erro');
    const icone = el.querySelector('.sw-status-icone');
    if (icone) {
      icone.classList.remove('aguardando');
      icone.innerHTML = '&#x2717;';
    }
    const span = el.querySelector('span:last-child');
    if (span) span.textContent = texto;
  }

  esconderEMostrarJogo(): void {
    this.elemento.classList.add('escondido');
    this.elJogo.classList.add('visivel');
  }
}

function obrigatorio(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Elemento #${id} nao encontrado no DOM`);
  return el;
}
